export default "__VITE_ASSET__Dzey5k9D__"